import React, { useEffect, useState } from "react";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";
import getFormattedDistance from "../../utils/getDistance";
import MuiSelect from "../common/MuiSelect";

import { types } from "../../utils/static";
import "./adminContact.css";
import formatPhoneNumber from "../../utils/formatNumber";
import { Modal } from "react-bootstrap";
import {
  Chip,
  Button,
  Stack,
  TextField,
  CircularProgress,
  Select,
  Divider,
  Pagination,
} from "@mui/material";
import { ArrowForward, Logout } from "@mui/icons-material";
import toast from "react-hot-toast";
import formatDuration from "../../utils/formatDuration";
import { useNavigate } from "react-router-dom";
const ContactList = () => {
  const [numbers, setNumber] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedType, setSelectedType] = useState("all");
  const [selectedUser, setSelectedUser] = useState("");
  const [userFilter, setUserFilter] = useState("");
  const [loading, setLoadng] = useState(false);
  const [q, setQ] = useState("");
  const [page, setPage] = useState();
  const [totalpages, setTotalPages] = useState(1);
  const navigate = useNavigate();
  const getdminContacts = async () => {
    const data = {
      url:
        apis().getContacts +
        `?type=${selectedType}&&search=${q}&&userId=${userFilter}&&page=${page}`,
    };
    setLoadng(true);
    const result = await httpAction(data);
    setLoadng(false);
    if (result?.status) {
      setTotalPages(result?.pagination);
      setNumber(result?.contacts);
      setPage(result?.pagination?.currentPage);
    }
  };
  const getUserList = async () => {
    const data = {
      url: apis().getUserList,
    };
    const result = await httpAction(data);

    if (result?.status) {
      setUsers(result?.list);
    }
  };
  useEffect(() => {
    getUserList();
  }, []);

  useEffect(() => {
    getdminContacts();
  }, [selectedType, q, userFilter, page]);

  // Handle checkbox selection
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectedContacts(
      isChecked ? numbers.map((contact) => contact.number) : [],
    );
  };

  const handleSelectContact = (e, contactId) => {
    if (e.target.checked) {
      setSelectedContacts((prev) => [...prev, contactId]);
    } else {
      setSelectedContacts((prev) => prev.filter((id) => id !== contactId));
    }
  };

  const userSelectChange = (event) => {
    setSelectedUser(event);
  };

  const searchChange = (e) => {
    setQ(e.target.value);
  };

  const handleAssign = async () => {
    const userId = users.find((item) => item.name === selectedUser);
    const data = {
      url: apis().assignContact + `?userId=${userId._id}`,
      method: "POST",
      body: { numbers: selectedContacts },
    };

    const result = await httpAction(data);
    if (result?.status) {
      toast.success(result?.message);

      setSelectedContacts([]);
      setSelectedUser("");
      await getdminContacts();
    }
  };

  const userFilterChnage = (value) => {
    const userId = users.find((item) => item.name === value);
    if (userId?._id) {
      setUserFilter(userId._id);
    } else {
      setUserFilter("");
    }
  };

  return (
    <div>
      <div className="container">
        <div
          style={{
            padding: "1erm 0",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <TextField
              onChange={searchChange}
              value={q}
              size="small"
              fullWidth
              label="serach here"
            />
            <MuiSelect
              items={users}
              handleChange={userSelectChange}
              label="User assign to"
              value={selectedUser}
            />
            <MuiSelect
              items={users}
              handleChange={userFilterChnage}
              label="Filter By User"
              value={userFilter}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Stack direction="row" spacing={2}>
                {['today','last 3 days',...types]?.map((item, index) => (
                  <Chip
                    key={index}
                    onClick={() => {
                      setPage(1);
                      setSelectedType(item);
                    }}
                    color={selectedType === item ? "success" : "default"}
                    label={item}
                    size="small"
                  />
                ))}
              </Stack>
            </div>

            <div>
              <Stack direction="row" spacing={2}>
                <Chip
                  color="primary"
                  size="small"
                  label={`total cntacts: ${totalpages?.totalContacts}`}
                />
              </Stack>
            </div>
            <Button
              onClick={() => {
                localStorage.removeItem("userId");
                navigate("/login");
              }}
              variant="outlined"
              endIcon={<Logout />}
            >
              Logout
            </Button>
            <Button
              disabled={selectedContacts.length === 0 || !selectedUser}
              endIcon={<ArrowForward />}
              variant="contained"
              onClick={handleAssign}
            >
              Assign Contacts
            </Button>
          </div>
        </div>

        <table className="contact-table">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={selectedContacts.length === numbers.length}
                />
              </th>
              <th>Name</th>
              <th>Phone</th>
              <th>Dial Count</th>
              <th>Project</th>
              <th>Source</th>
              <th>Rating</th>
              <th>Type</th>
              <th>User</th>
              <th>Last Dialed</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <div className="user_contact_loading">
                <span>Loading...</span>
                <CircularProgress size={24} />
              </div>
            ) : (
              numbers.map((item) => (
                <TableRow
                  key={item._id}
                  item={item}
                  handleSelectContact={handleSelectContact}
                  selectedContacts={selectedContacts}
                />
              ))
            )}
            {!loading && numbers.length === 0 && (
              <span
                style={{
                  color: "gray",
                  display: "inline-block",
                  padding: "2rem",
                  textAlign: "center",
                  width: "100%",
                  textTransform: "capitalize",
                }}
              >
                no contact found
              </span>
            )}
          </tbody>
        </table>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Pagination
            onChange={(item, value) => setPage(value)}
            color="success"
            count={totalpages?.totalPages}
          />
        </div>
      </div>
    </div>
  );
};

function TableRow({ item, handleSelectContact, selectedContacts }) {
  const isChecked = selectedContacts.includes(item?.number);
  const [opendetail, setOpenDetail] = useState(false);

  const detailOpenHandler = () => {
    setOpenDetail(true);
  };

  return (
    <tr>
      <Modal show={opendetail} onHide={() => setOpenDetail(false)}>
        <Modal.Header closeButton>
          <Modal.Title>History of: {item?.number}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {item?.callHistory?.map((his, index) => (
              <div key={index} className="user_call_his_main">
                <Stack spacing={1}>
                  <div className="d-flex justify-content-between">
                    <Chip label="Dialed" size="small" />
                    <Chip
                      color="warning"
                      label={
                        getFormattedDistance(his?.callStartAt) + " " + "ago"
                      }
                      size="small"
                    />
                  </div>
                  <Divider />
                  <div className="d-flex justify-content-between">
                    <Chip label="Call Duration" size="small" />
                    <Chip
                      color="default"
                      label={formatDuration(his?.callDuration)}
                      size="small"
                    />
                  </div>
                  <Divider />
                  <span style={{ color: "gray", fontSize: "14px" }}>Note</span>
                  <textarea
                    readOnly
                    value={his?.detail}
                    rows={3}
                    className="user_call_his_detail"
                  />
                </Stack>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
      <td>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={(e) => handleSelectContact(e, item?.number)}
        />
      </td>
      <td>{item?.name}</td>
      <td>{formatPhoneNumber(item?.number)}</td>
      <td>{item?.dailCount}</td>
      <td>{item?.project}</td>
      <td>{item?.source}</td>
      <td>{item?.rating}</td>
      <td>
        <Chip
        size="small"
          label={item?.type}
          color={item?.type === "undailed" ? "warning" : "default"}
        />
      </td>
      <td>{item?.user?.name}</td>
      <td>{getFormattedDistance(item?.lastDailDate)}</td>
      <td style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
        <button>Edit</button>
        <button>Delete</button>
        <button onClick={detailOpenHandler}>Detail</button>
      </td>
    </tr>
  );
}

export default ContactList;
